<template>
    <div>
    <header class="wrapper-header">
        <loader v-if="loading"></loader>
        <!-- header section -->

        <nav class="theme-dark header">
            <div class="container">
                <div class="row">
                    
                    <!-- LOGO -->
                    <div class="col-lg-1 col-md-2">
                        <div class="logo img-fluid">
                            <router-link to="/">
                            <img :src="logo.image">
                            </router-link>
                        </div>
                    </div>

                    <!-- DESKTOP MENU -->
                    <div class="col-lg-11 col-md-10 display-center">
                        <div class="nav-link header-link">
                        <ul>

                            <li :class="{active: isRoute('Home')}">
                                <router-link to="/home"><i class="fa fa-home"></i> Hogar</router-link>
                            </li>

                            <li :class="{active: isRoute('AllMusicCategory') || isRoute('CategoryMusic')}">
                                <router-link to="/allcategory"><i class="fa fa-music"></i> Música</router-link>
                            </li>

                            <li :class="{active: isRoute('LiveRadio')}">
                                <router-link to="/liveradio"><i class="fa fa-microphone"></i> Radio</router-link>
                            </li>

                            <li :class="{active: isRoute('Events')}">
                                <router-link to="/events"><i class="fa fa-eye"></i> Eventos</router-link>
                            </li>

                            <li :class="{active: isRoute('Program')}">
                                <router-link to="/program"><i class="fa fa-eye"></i> Horarios</router-link>
                            </li>

                            <li :class="{active: isRoute('LiveVideo')}">
                                <router-link to="/livevideo"><i class="fa fa-video-camera"></i> Vistas previas de la transmisión</router-link>
                            </li>

                            <!-- <li :class="{active: isRoute('Liveevent')}">
                                <router-link to="/liveevent"><i class="fa fa-calendar-o"></i> Broadcasting Live</router-link>
                            </li> -->

                            <!-- SHOW ONLY IF NOT LOGGED IN -->
                            <!-- <li v-if="!isLoggedIn" :class="{active: isRoute('Playlist')}">
                                <router-link to="/playlist"><i class="fa fa-play-circle-o"></i> Mi lista de reproducción</router-link>
                            </li>

                            <li v-if="!isLoggedIn" :class="{active: isRoute('Favourites')}">
                                <router-link to="/favourites"><i class="fa fa-heart"></i> Mis favoritos</router-link>
                            </li> -->
                            <li :class="{active: isRoute('Premium')}">
                                <router-link to="/premium" style="font-size: 14px; font-weight: 800; color:#d70606"><i class="fa fa-envelope"></i> Suscripción Premium</router-link>
                            </li>
                            <li :class="{active: isRoute('ContactUs')}">
                                <router-link to="/contactus"><i class="fa fa-envelope"></i> Información</router-link>
                            </li>
                            

                            <li>
                                <router-link to="/search">
                                <i class="fa fa-search"></i>
                                </router-link>
                            </li>

                            <!-- AUTH DROPDOWN (ONLY IF NOT LOGGED IN) -->
                            <li v-if="!isLoggedIn" class="profile-menu" ref="guestMenu">

                                <div class="profile-wrapper" @click.stop="toggleGuestDropdown">
                                    <i class="fa fa-user-circle guest-icon"></i>
                                </div>

                                <transition name="fade-dropdown">
                                    <div v-if="showGuestDropdown" class="luinny-dropdown">

                                        <div class="dropdown-item">
                                            <router-link to="/login">
                                            <i class="fa fa-sign-in"></i> Acceso
                                            </router-link>
                                        </div>

                                        <div class="dropdown-item">
                                            <router-link to="/register">
                                            <i class="fa fa-user-plus"></i> Registro
                                            </router-link>
                                        </div>
                                        <div class="dropdown-item">
                                            <router-link to="/playlist">
                                            <i class="fa fa-sign-in"></i> Mi lista de reproducción
                                            </router-link>
                                        </div>

                                        <div class="dropdown-item">
                                            <router-link to="/favourites">
                                            <i class="fa fa-user-plus"></i> Mis favoritos
                                            </router-link>
                                        </div>

                                    </div>
                                </transition>

                            </li>

                            <!-- PROFILE MENU -->
                            <li v-if="isLoggedIn" class="profile-menu" ref="profileMenu">
                                <div class="profile-wrapper" @click.stop="toggleDropdown">
                                <img :src="authUser && authUser.profile_image ? authUser.profile_image : defaultAvatar" class="profile-img">
                                </div>

                                <transition name="fade-dropdown">
                                    <div v-if="showDropdown" class="luinny-dropdown">
                                        <div class="dropdown-item">
                                        <router-link to="/profile">
                                            <i class="fa fa-user"></i> Perfil
                                        </router-link>
                                        </div>

                                        <div class="dropdown-item">
                                        <router-link to="/playlist">
                                            <i class="fa fa-play-circle"></i> Mi lista de reproducción
                                        </router-link>
                                        </div>

                                        <div class="dropdown-item">
                                        <router-link to="/favourites">
                                            <i class="fa fa-heart"></i> Mis favoritos
                                        </router-link>
                                        </div>
                                        <div class="dropdown-item">
                                        <router-link to="/subscription">
                                            <i class="fa fa-heart"></i> Suscripción
                                        </router-link>
                                        </div>
                                        <div class="dropdown-item">
                                        <router-link to="/subscription-history">
                                            <i class="fa fa-heart"></i> Historial de suscripción
                                        </router-link>
                                        </div>

                                        <div class="dropdown-divider"></div>

                                        <div class="dropdown-item logout" @click="logout">
                                        <i class="fa fa-sign-out"></i> Cerrar sesión
                                        </div>
                                    </div>
                                </transition>
                            </li>

                            </ul>
                        </div>
                    </div>

                    <!-- MOBILE HAMBURGER -->
                    <div class="col-6 d-lg-none text-right">
                        <div class="hamburger" @click="toggleMobileMenu">
                        <i class="fas fa-bars"></i>
                        </div>
                    </div>


                </div>
            </div>
         </nav>
        <!-- End header section -->

        <!-- mobile siderbar -->
        <div class="mobile-menu" :class="{ active: mobileMenuOpen }">
            <div class="siderbar-mobile">
                
                
                <div class="mobile-link">
                    <ul>

                        <!-- 🔥 PROFILE SECTION (Only if Logged In) -->
                        <li v-if="isLoggedIn" class="mobile-profile-section">
                            <div class="mobile-profile-wrapper">
                            <img
                                :src="authUser.profile_image ? authUser.profile_image : defaultAvatar"
                                class="mobile-profile-img"
                            />
                            <div class="mobile-profile-info">
                                <span class="mobile-name">{{ authUser.name }}</span>
                                <span class="mobile-email">{{ authUser.email }}</span>
                            </div>
                            </div>
                        </li>

                        <li v-if="!isLoggedIn" :class="{active: isRoute('Login')}">
                                <router-link to="/login"><i class="fa fa-play-circle-o"></i> Login</router-link>
                        </li>
                        <li v-if="!isLoggedIn" :class="{active: isRoute('Register')}">
                                <router-link to="/register"><i class="fa fa-play-circle-o"></i> Register</router-link>
                        </li>
                        <li v-if="isLoggedIn">
                            <router-link to="/profile">
                            <i class="fa fa-user"></i> &nbsp;Profile
                            </router-link>
                        </li>

                        <!-- NORMAL MENU -->
                        <li :class="{active: isRoute('Home')}">
                            <router-link to="/home"><i class="fa fa-home"></i> &nbsp;Home</router-link>
                        </li>

                        <li :class="{active: isRoute('AllMusicCategory') || isRoute('CategoryMusic')}">
                            <router-link to="/allcategory"><i class="fa fa-music"></i> &nbsp;Music</router-link>
                        </li>

                        <li :class="{active: isRoute('LiveRadio')}">
                            <router-link to="/liveradio"><i class="fa fa-microphone"></i> &nbsp;Radio</router-link>
                        </li>

                        <li :class="{active: isRoute('Events')}">
                            <router-link to="/events"><i class="fa fa-eye"></i> &nbsp;Events</router-link>
                        </li>

                        <li :class="{active: isRoute('Program')}">
                            <router-link to="/program"><i class="fa fa-eye"></i> &nbsp;Showtimes</router-link>
                        </li>

                        <li :class="{active: isRoute('LiveVideo')}">
                            <router-link to="/livevideo"><i class="fa fa-video-camera"></i> &nbsp;Stream Previews</router-link>
                        </li>
                        <li :class="{active: isRoute('Premium')}">
                                <router-link to="/premium" style="font-size: 14px; font-weight: 800;"><i class="fa fa-envelope"></i> Premium Subscription</router-link>
                        </li>
                        <!-- <li :class="{active: isRoute('Liveevent')}">
                            <router-link to="/liveevent"><i class="fa fa-calendar-o"></i> &nbsp;Broadcasting Live</router-link>
                        </li> -->

                        <li :class="{active: isRoute('Playlist')}">
                            <router-link to="/playlist"><i class="fa fa-play-circle-o"></i> &nbsp;Mi lista de reproducción</router-link>
                        </li>

                        <li :class="{active: isRoute('Favourites')}">
                            <router-link to="/favourites"><i class="fa fa-heart"></i> &nbsp;Mis favoritos</router-link>
                        </li>
                        <li :class="{active: isRoute('subscription')}">
                            <router-link to="/subscription"><i class="fa fa-heart"></i> &nbsp;Subscription</router-link>
                        </li>
                        <li :class="{active: isRoute('SubscriptionHistory')}">
                            <router-link to="/subscription-history"><i class="fa fa-heart"></i> &nbsp;My Historial de suscripción</router-link>
                        </li>

                        <li :class="{active: isRoute('ContactUs')}">
                            <router-link to="/contactus"><i class="fa fa-envelope"></i> &nbsp;Info</router-link>
                        </li>

                        <li :class="{active: isRoute('search')}">
                            <router-link to="/search">
                            <i class="fa fa-search"></i> &nbsp;Search
                            </router-link>
                        </li>

                        <!-- 🔥 LOGOUT -->
                        <li v-if="isLoggedIn" @click="logout" class="mobile-logout">
                            <i class="fa fa-sign-out"></i> &nbsp;Logout
                        </li>

                    </ul>
                </div>
                
            </div>
            
        </div>
        <div v-if="mobileMenuOpen" class="overlay" @click="closeMobileMenu"></div>
    </header>
    <div class="home top-spacing bg-grey">
        <SponsorBanner v-if="!isLiveRadioRoute" :sponsorBanner="sponsor_banner"></SponsorBanner>
    </div>	
    </div>
</template>
<script>
import { HTTP } from '../../_helper/http-constants.js';
import SponsorBanner from './../home/sponsorbanner.vue';

export default {
  name: 'headernav',
  components: { SponsorBanner },

  data() {
    return {
        user: JSON.parse(localStorage.getItem('user')),
        authUser: JSON.parse(localStorage.getItem('user')),
        logo: '',
        loading: false,
        sponsor_banner: null,
        showDropdown: false,
        defaultAvatar: 'https://i.pravatar.cc/100',
        mobileMenuOpen: false,
        showGuestDropdown: false,
    };
  },

  computed: {
    isLoggedIn() {
      return this.authUser && this.authUser.email;
    },

    isLiveRadioRoute() {
      if (!this.$route.name) return false;
      const name = this.$route.name.toLowerCase();
      return name === 'liveradio' || name === 'program';
    }
  },

    methods: {
        isRoute(name) {
            return this.$route.name === name;
        },

        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },

        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },

        toggleGuestDropdown() {
            this.showGuestDropdown = !this.showGuestDropdown;
        },

        closeMobileMenu() {
            this.mobileMenuOpen = false;
        },

        handleOutsideClick(e) {
            if (this.$refs.profileMenu && 
                !this.$refs.profileMenu.contains(e.target)) {
                this.showDropdown = false;
            }

            if (this.$refs.guestMenu &&
                !this.$refs.guestMenu.contains(e.target)) {
                this.showGuestDropdown = false;
            }
        },

        refreshUser() {
            this.authUser = JSON.parse(localStorage.getItem('user'));
        },

        async logout() {
            try {
                await HTTP.post('/auth/logout');
            } catch (e) {
                console.error('Logout error:', e);
            }

            localStorage.removeItem('token');
            localStorage.removeItem('user');

            await this.createGuestUser();

            this.authUser = null;   // 🔥 IMPORTANT
            this.showDropdown = false;

            this.$router.push('/login');
        },

        async createGuestUser() {
            try {
                const res = await HTTP.post('/appusers', {
                    device_type: 'web',
                    token: null
                    });

                    if (res.data.status === 200) {
                    const guestUser = {
                        user_id: res.data.user_id,
                        device_type: res.data.device_type,
                        token: res.data.token
                    };

                    localStorage.setItem('user', JSON.stringify(guestUser));
                }
            } catch (e) {
                console.log('Guest user creation failed', e);
            }
        },
        getHeaderData() {
            this.loading = true;

            HTTP.get('/cms')
            .then(res => {
                if (res.data.status === 200) {
                this.logo = res.data.logo_data[0];
                this.sponsor_banner = res.data.sponsorbanner_data;
                }
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            });
        }
    },

    mounted() {
        this.refreshUser();
        this.getHeaderData();

        document.addEventListener('click', this.handleOutsideClick);

        // 🔥 Listen for login event
        window.addEventListener('user-logged-in', this.refreshUser);
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
        window.removeEventListener('user-logged-in', this.refreshUser);
    },

  watch: {
    $route() {
      this.showDropdown = false;
      this.mobileMenuOpen = false;
    }
  }
};
</script>